import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, EventEmitter, OnInit, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MapApi } from '../../../api/map-api';
import { UserApi } from '../../../api/user-api';
import { environment } from '../../../environment';
import { BooleanConverter, InputConverter } from '../../../inputConverter';
import { MapService } from '../../../services/map.service';
import { LogLevel } from '../../../types';
import { BaseComponent } from '../../base.component';
/* tslint:disable:template-cyclomatic-complexity */
var MapCatalogComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MapCatalogComponent, _super);
    function MapCatalogComponent(_vcr, _formBuilder, mapService, userApi, mapApi, authService, LoggingService, cdr) {
        var _this = _super.call(this, _vcr) || this;
        _this._formBuilder = _formBuilder;
        _this.mapService = mapService;
        _this.userApi = userApi;
        _this.mapApi = mapApi;
        _this.authService = authService;
        _this.LoggingService = LoggingService;
        _this.cdr = cdr;
        _this.applicationId = environment.appId;
        _this.mergeMaps = false;
        _this.showOnlyApplicationUserMaps = false;
        _this.tabIndex = 0;
        _this.loggedIn = false;
        _this._userId = null;
        _this.shouldLogIn = new EventEmitter();
        _this.ondone = new EventEmitter();
        _this.onmapopened = new EventEmitter();
        _this.openmergemap = new EventEmitter();
        _this.opensharemap = new EventEmitter();
        _this.systemMaps = [];
        _this.limit = 10;
        _this.searchInputControl = new FormControl();
        _this.debounceTime = 500;
        _this.searchText = '';
        _this.filteredResultCount = { Count: 0 };
        _this.systemMapErrorMessage = null;
        _this.userMaps = [];
        _this.filteredUserMaps = [];
        _this.userMapFolders = [];
        _this.userMapErrorMessage = null;
        _this.multiSelectEnabled = false;
        _this.canViewUsers = false;
        _this.systemLoading = { status: false, text: 'Loading...' };
        _this.folderEditing = false;
        _this.parentFolders = [];
        _this.userMapSortByEdited = false;
        _this.registerEvent('shouldLogIn', _this.shouldLogIn);
        _this.registerEvent('ondone', _this.ondone);
        _this.registerEvent('onmapopened', _this.onmapopened);
        _this.registerEvent('openmergemap', _this.openmergemap);
        _this.registerEvent('opensharemap', _this.opensharemap);
        _this.searchInputForm = _this._formBuilder.group({
            searchInput: _this.searchInputControl
        });
        authService.permissions.subscribe(function (permissions) {
            _this.canViewUsers = permissions && permissions.includes('View Users');
        });
        return _this;
    }
    Object.defineProperty(MapCatalogComponent.prototype, "userId", {
        get: function () { return this._userId; },
        set: function (value) {
            this._userId = value;
            this.loadUserData();
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogComponent.prototype, "showSystemMaps", {
        get: function () {
            return this._showSystemMaps;
        },
        set: function (value) {
            this._showSystemMaps = value;
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogComponent.prototype, "showUserMaps", {
        get: function () {
            return this._showUserMaps;
        },
        set: function (value) {
            this._showUserMaps = value;
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogComponent.prototype, "active", {
        get: function () {
            return this._active;
        },
        set: function (value) {
            value = BooleanConverter(value);
            if (value) {
                this.onActivate();
            }
            this._active = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogComponent.prototype, "pageSize", {
        get: function () {
            return Math.ceil(this.filteredResultCount.Count / this.limit);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MapCatalogComponent.prototype, "pageSizeArray", {
        get: function () {
            return [].constructor(this.pageSize);
        },
        enumerable: true,
        configurable: true
    });
    MapCatalogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.searchInputControl
            .valueChanges
            .pipe(debounceTime(this.debounceTime), distinctUntilChanged()).subscribe(function (searchText) {
            _this.searchText = searchText;
            _this.searchTerm = { keys: ['name', 'description'], searchTerm: searchText };
            _this.current = 0;
            _this.loadFilteredUserMaps();
        });
        this.treeOptions = {};
        this.loading = { status: false, text: 'Loading...' };
        this.newFolderName = new FormControl('', [Validators.required, this.nameInUse.bind(this)]); //tslint:disable-line
    };
    Object.defineProperty(MapCatalogComponent.prototype, "mapsSelected", {
        get: function () {
            if (this.userMaps) {
                return this.userMaps.map(function (x) { return x.map; }).filter(function (x) { if (x && x.selected) {
                    return x;
                } });
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    MapCatalogComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.setupMapViewRef(this.mapViewRef)];
                    case 1:
                        _a.mapViewRef = _b.sent();
                        this.isReady();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.onActivate = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var loadingPromises;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearError();
                        loadingPromises = [];
                        this.multiSelectEnabled = false;
                        if (this._showSystemMaps) {
                            loadingPromises.push(this.loadSystemMaps());
                        }
                        if (this.userId === null) {
                            this.authService.GetCurrentUser().subscribe(function (user) {
                                if (user) {
                                    _this.userId = user.id;
                                }
                            });
                        }
                        else {
                            loadingPromises.push(this.loadUserData());
                        }
                        //await each task while they work in the background so no hold up of user maps is done by awaiting system maps
                        return [4 /*yield*/, Promise.all(loadingPromises)];
                    case 1:
                        //await each task while they work in the background so no hold up of user maps is done by awaiting system maps
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.loadUserData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.loading = { status: true, text: 'Loading...' };
                        if (!this.userId) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, this.applicationId, 'maps')];
                    case 1:
                        _a.parentFolders = _b.sent();
                        this.parentFolders.sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()); });
                        this.parentFolders.push({ name: 'No parent', id: 0 });
                        _b.label = 2;
                    case 2: return [4 /*yield*/, this.getUserMapsAndFoldersForUserId()];
                    case 3:
                        _b.sent();
                        this.loadFilteredUserMaps();
                        this.loading.status = false;
                        this.cdr.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.loadSystemMaps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, applications, maps, maps_1, maps_1_1, map, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.systemLoading = { status: true, text: 'Loading...' };
                        this.systemMaps = [];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.mapService.getSystemMaps(this.applicationId, false)];
                    case 2:
                        applications = _b.sent();
                        maps = applications[0].maps;
                        try {
                            for (maps_1 = tslib_1.__values(maps), maps_1_1 = maps_1.next(); !maps_1_1.done; maps_1_1 = maps_1.next()) {
                                map = maps_1_1.value;
                                this.systemMaps.push(map);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (maps_1_1 && !maps_1_1.done && (_a = maps_1.return)) _a.call(maps_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        this.systemMaps.sort(function (a, b) { return a.name.localeCompare(b.name); });
                        this.current = 0;
                        this.filteredResultCount.Count = this.systemMaps.length;
                        this.systemLoading.status = false;
                        this.cdr.detectChanges();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        this.systemMapErrorMessage = 'There was an error fetching maps';
                        this.LoggingService.Log('Error fetching maps from database', error_1, LogLevel.Error);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.getUserMapsAndFoldersForUserId = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var getUserMapFoldersPromise, appIdFilter, userMaps, userMapFolders, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.userMaps = [];
                        if (!this.userId) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        getUserMapFoldersPromise = this.mapService.getUserMapsFolders(this.userId, this.applicationId);
                        appIdFilter = null;
                        if (this.showOnlyApplicationUserMaps) {
                            appIdFilter = this.applicationId;
                        }
                        return [4 /*yield*/, this.mapService.getUserMaps(this.userId, appIdFilter)];
                    case 2:
                        userMaps = _a.sent();
                        //get the maps by the provided ids back from UserMaps to get their data
                        this.userMaps = userMaps && userMaps[0] && userMaps[0].userMaps ? userMaps[0].userMaps : [];
                        // Set date strings to dates
                        this.userMaps.filter(function (x) { return x.map; }).forEach(function (userMap) {
                            if (typeof userMap.map.lastEditedDate === 'string') {
                                userMap.map.lastEditedDate = new Date(userMap.map.lastEditedDate);
                            }
                            if (typeof userMap.map.createdDate === 'string') {
                                userMap.map.createdDate = new Date(userMap.map.createdDate);
                            }
                        });
                        return [4 /*yield*/, getUserMapFoldersPromise];
                    case 3:
                        userMapFolders = _a.sent();
                        this.userMapFolders = userMapFolders && userMapFolders[0] && userMapFolders[0].folders ? userMapFolders[0].folders : [];
                        return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        this.systemMapErrorMessage = 'There was an error fetching maps';
                        this.LoggingService.Log('Error fetching maps from database', error_2, LogLevel.Error);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        this.userMaps = [];
                        this.userMapFolders = [];
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.loadFilteredUserMaps = function () {
        var _this = this;
        this.filteredUserMaps = this.userMaps.filter(function (x) { if (x.map) {
            return _this.isMatchToSearchText(x.map.name, x.map.description);
        } });
        this.setTree(this.userMapFolders, this.filteredUserMaps);
        this.treeOptions = {};
    };
    MapCatalogComponent.prototype.isMatchToSearchText = function (name, description) {
        var e_2, _a, e_3, _b;
        var nameLower = name.toLowerCase();
        var searchTextLower = this.searchText.toLowerCase();
        var searchTermArray = searchTextLower.split(' ');
        var allTermsFoundName = true;
        try {
            for (var searchTermArray_1 = tslib_1.__values(searchTermArray), searchTermArray_1_1 = searchTermArray_1.next(); !searchTermArray_1_1.done; searchTermArray_1_1 = searchTermArray_1.next()) {
                var term = searchTermArray_1_1.value;
                allTermsFoundName = allTermsFoundName && nameLower.indexOf(term) >= 0;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (searchTermArray_1_1 && !searchTermArray_1_1.done && (_a = searchTermArray_1.return)) _a.call(searchTermArray_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        var allTermsFoundDesc = false;
        if (description) {
            var descLower = description.toLowerCase();
            allTermsFoundDesc = true;
            try {
                for (var searchTermArray_2 = tslib_1.__values(searchTermArray), searchTermArray_2_1 = searchTermArray_2.next(); !searchTermArray_2_1.done; searchTermArray_2_1 = searchTermArray_2.next()) {
                    var term = searchTermArray_2_1.value;
                    allTermsFoundDesc = allTermsFoundDesc && descLower.indexOf(term) >= 0;
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (searchTermArray_2_1 && !searchTermArray_2_1.done && (_b = searchTermArray_2.return)) _b.call(searchTermArray_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        return allTermsFoundName || allTermsFoundDesc;
    };
    MapCatalogComponent.prototype.clearError = function () {
        this.systemMapErrorMessage = null;
        this.userMapErrorMessage = null;
    };
    MapCatalogComponent.prototype.setTree = function (userMapsFolders, userMaps) {
        var _this = this;
        this.userMapNodes = [];
        var userMapNodesTemp = [];
        var userMapSort = function (a, b) { return a.map.name.localeCompare(b.map.name); };
        if (this.userMapSortByEdited) {
            userMapSort = function (a, b) { return b.map.lastEditedDate.valueOf() - a.map.lastEditedDate.valueOf(); };
        }
        if (userMapsFolders) {
            userMapsFolders.sort(function (a, b) { return a.name.localeCompare(b.name); });
            userMaps.sort(userMapSort);
            userMapNodesTemp.push.apply(userMapNodesTemp, tslib_1.__spread(userMapsFolders.filter(function (f) { return !f.parentUserFolderId || f.parentUserFolderId === 0; }).map(function (f) { return _this.buildTreeNode(f, userMapsFolders, userMaps); })));
        }
        // Add orphan maps
        userMapNodesTemp.push.apply(userMapNodesTemp, tslib_1.__spread(userMaps.map(function (m) {
            var mapObj = m.map;
            mapObj.accessLevel = m.accessLevel;
            mapObj.sharedWith = m.sharedWith || [];
            return {
                children: [],
                id: m.map.id,
                map: mapObj,
                name: m.map.name,
                nodeType: 'leaf',
                owner: _this.isUserOwnerOfMap(m)
            };
        })));
        this.userMapNodes = userMapNodesTemp;
    };
    MapCatalogComponent.prototype.getChildMaps = function (folder, userMaps) {
        var childMaps = [];
        folder.maps.forEach(function (fm) {
            var userMap = userMaps.find(function (um) { return um.map.id === fm.id; });
            if (userMap) {
                childMaps.push(userMap);
                var idx = userMaps.indexOf(userMap);
                userMaps.splice(idx, 1);
            }
        });
        var userMapSort = function (a, b) { return a.map.name.localeCompare(b.map.name); };
        if (this.userMapSortByEdited) {
            userMapSort = function (a, b) { return b.map.lastEditedDate.valueOf() - a.map.lastEditedDate.valueOf(); };
        }
        childMaps.sort(userMapSort);
        return childMaps;
    };
    MapCatalogComponent.prototype.buildTreeNode = function (folder, userfolders, userMaps) {
        var _this = this;
        var _a, _b;
        var childFolders = userfolders.filter(function (f) { return f.parentUserFolderId === folder.id; });
        var childMaps = this.getChildMaps(folder, userMaps);
        var groupNode = {
            children: [],
            id: folder.id,
            name: folder.name,
            nodeType: 'group'
        };
        (_a = groupNode.children).push.apply(_a, tslib_1.__spread(childMaps.map(function (m) {
            m.map.accessLevel = m.accessLevel;
            m.map.sharedWith = m.sharedWith;
            return {
                children: [],
                id: m.map.id,
                map: m.map,
                name: m.map.name,
                nodeType: 'leaf',
                owner: _this.isUserOwnerOfMap(m)
            };
        })));
        (_b = groupNode.children).push.apply(_b, tslib_1.__spread(childFolders.map(function (cf) { return _this.buildTreeNode(cf, userfolders, userMaps); })));
        return groupNode;
    };
    MapCatalogComponent.prototype.go = function (page) {
        this.current = page;
    };
    MapCatalogComponent.prototype.previous = function () {
        if (this.current === 0) {
            return;
        }
        this.current--;
    };
    MapCatalogComponent.prototype.next = function () {
        if (this.current === this.pageSize - 1) {
            return;
        }
        this.current++;
    };
    MapCatalogComponent.prototype.editFolder = function (folder) {
        this.currentFolderId = folder.id;
        var parentFolder = this.parentFolders.find(function (f) { return f.id === folder.id; });
        this.parentFolderId = parentFolder ? parentFolder.parentUserFolderId : null;
        this.newFolderName.setValue(folder.name);
        this.showFolderEditor = true;
        this.folderEditing = true;
    };
    MapCatalogComponent.prototype.addFolder = function (folder) {
        this.currentFolderId = null;
        this.parentFolderId = folder ? folder.id : undefined;
        this.showFolderEditor = true;
        this.newFolderName.setValue('');
        this.folderEditing = false;
    };
    MapCatalogComponent.prototype.newFolder = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var folder, _a, error_3;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        folder = {
                            name: this.newFolderName.value,
                            category: 'maps',
                            parentUserFolderId: this.parentFolderId,
                            userId: this.userId,
                            applicationId: this.applicationId
                        };
                        if (this.currentFolderId) {
                            folder.id = this.currentFolderId;
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, 6, 7]);
                        this.showFolderEditor = false;
                        this.loading = { status: true, text: 'Creating new folder...' };
                        return [4 /*yield*/, this.userApi.createNewUserFolder(folder)];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.getUserMapsAndFoldersForUserId()];
                    case 3:
                        _b.sent();
                        this.loadFilteredUserMaps();
                        _a = this;
                        return [4 /*yield*/, this.userApi.queryUserFolders(this.userId, this.applicationId, 'maps')];
                    case 4:
                        _a.parentFolders = _b.sent();
                        this.parentFolders.sort(function (a, b) { return a.name.toLowerCase().localeCompare(b.name.toLowerCase()); });
                        this.parentFolders.push({ name: 'No parent', id: 0 });
                        return [3 /*break*/, 7];
                    case 5:
                        error_3 = _b.sent();
                        this.LoggingService.Log(error_3, LogLevel.Error);
                        return [3 /*break*/, 7];
                    case 6:
                        this.loading.status = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.deleteFolder = function (folder) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var error_4;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.confirm('Are you sure you want to delete this folder and all maps it contains?')) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 6]);
                        this.loading = { status: true, text: 'Deleting folder...' };
                        return [4 /*yield*/, this.deleteFolderAndMaps(folder)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        error_4 = _a.sent();
                        this.systemMapErrorMessage = 'There was an error deleting the folder.';
                        this.LoggingService.Log('Error deleting folder.', error_4, LogLevel.Error);
                        return [3 /*break*/, 6];
                    case 4:
                        this.loading = { status: true, text: 'Loading...' };
                        this.parentFolders = this.parentFolders.filter(function (f) { return f.id !== folder.id; });
                        return [4 /*yield*/, this.getUserMapsAndFoldersForUserId()];
                    case 5:
                        _a.sent();
                        this.loadFilteredUserMaps();
                        this.loading.status = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.deleteFolderAndMaps = function (folder) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_4, _a, _b, _c, child, e_4_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 8, 9, 10]);
                        _b = tslib_1.__values(folder.children), _c = _b.next();
                        _d.label = 1;
                    case 1:
                        if (!!_c.done) return [3 /*break*/, 7];
                        child = _c.value;
                        if (!(child.nodeType === 'group')) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.deleteFolderAndMaps(child)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, this.mapApi.saveMapToUserFolder(child.id, 0, folder.id)];
                    case 4:
                        _d.sent();
                        return [4 /*yield*/, this.deleteMap(child.map, false)];
                    case 5:
                        _d.sent();
                        if (child.id === this.mapViewRef.mapcoreViewProps.id) {
                            this.resetMap();
                        }
                        _d.label = 6;
                    case 6:
                        _c = _b.next();
                        return [3 /*break*/, 1];
                    case 7: return [3 /*break*/, 10];
                    case 8:
                        e_4_1 = _d.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 10];
                    case 9:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 10: return [4 /*yield*/, this.userApi.deleteUserFolder(folder.id)];
                    case 11:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.pickFolder = function (mapId) {
        this.currentMapId = mapId;
        var parentFolder = this.userMapFolders.find(function (f) { return f.maps.find(function (m) { return m.id === mapId; }); });
        if (parentFolder) {
            this.parentFolderId = parentFolder.id;
        }
        this.showFolderPicker = true;
    };
    MapCatalogComponent.prototype.changeFolder = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var currentFolder, error_5;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.showFolderPicker = false;
                        this.loading = { status: true, text: 'Changing folder...' };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 6]);
                        currentFolder = this.userMapFolders.find(function (umf) { return umf.maps && umf.maps.length && umf.maps.some(function (m) { return m.id === _this.currentMapId; }); });
                        return [4 /*yield*/, this.mapApi.saveMapToUserFolder(this.currentMapId, this.parentFolderId, !!currentFolder ? currentFolder.id : null)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        error_5 = _a.sent();
                        this.LoggingService.Log(error_5, LogLevel.Error);
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.getUserMapsAndFoldersForUserId()];
                    case 5:
                        _a.sent();
                        this.loadFilteredUserMaps();
                        this.loading.status = false;
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.deleteMap = function (map, isSingle) {
        if (isSingle === void 0) { isSingle = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isOwner, error_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 12, 13, 16]);
                        isOwner = this.isUserOwnerOfMap(map);
                        if (!isOwner) return [3 /*break*/, 6];
                        if (!isSingle) return [3 /*break*/, 3];
                        if (!window.confirm('Are you sure you want to delete this map?')) return [3 /*break*/, 2];
                        this.loading = { status: true, text: 'Deleting Map...' };
                        return [4 /*yield*/, this.mapApi.deleteMap(map.id)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        this.loading = { status: true, text: 'Deleting Maps...' };
                        return [4 /*yield*/, this.mapApi.deleteMap(map.id)];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [3 /*break*/, 11];
                    case 6:
                        if (!isSingle) return [3 /*break*/, 9];
                        if (!window.confirm('Are you sure you want to no longer have this map shared with you?')) return [3 /*break*/, 8];
                        this.loading = { status: true, text: 'Removing Shared Map Association...' };
                        /* remove shared map association */
                        return [4 /*yield*/, this.mapApi.unShareMap([this.userId], map.id)];
                    case 7:
                        /* remove shared map association */
                        _a.sent();
                        _a.label = 8;
                    case 8: return [3 /*break*/, 11];
                    case 9:
                        this.loading = { status: true, text: 'Removing Shared Map Associations...' };
                        /* remove shared map association */
                        return [4 /*yield*/, this.mapApi.unShareMap([this.userId], map.id)];
                    case 10:
                        /* remove shared map association */
                        _a.sent();
                        _a.label = 11;
                    case 11:
                        if (map.id === this.mapViewRef.mapcoreViewProps.id) {
                            this.resetMap();
                        }
                        return [3 /*break*/, 16];
                    case 12:
                        error_6 = _a.sent();
                        this.LoggingService.Log(error_6, LogLevel.Error);
                        return [3 /*break*/, 16];
                    case 13:
                        if (!isSingle) return [3 /*break*/, 15];
                        return [4 /*yield*/, this.getUserMapsAndFoldersForUserId()];
                    case 14:
                        _a.sent();
                        this.loadFilteredUserMaps();
                        this.loading.status = false;
                        _a.label = 15;
                    case 15:
                        this.cdr.detectChanges();
                        return [7 /*endfinally*/];
                    case 16: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.deleteMulti = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapsToDelete, deleteMapIds, unshareMapIds, error_7;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!window.confirm('Are you sure you want to delete these maps?')) return [3 /*break*/, 7];
                        mapsToDelete = this.mapsSelected;
                        if (!(mapsToDelete.length > 0)) return [3 /*break*/, 7];
                        this.loading = { status: true, text: 'Deleting Maps...' };
                        deleteMapIds = mapsToDelete.filter(function (m) { return _this.isUserOwnerOfMap(m); }).map(function (m) { return m.id; });
                        unshareMapIds = mapsToDelete.filter(function (m) { return !_this.isUserOwnerOfMap(m); }).map(function (m) { return m.id; });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 7]);
                        return [4 /*yield*/, this.mapApi.deleteMaps(deleteMapIds)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.mapApi.unShareMaps([this.userId], unshareMapIds)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 4:
                        error_7 = _a.sent();
                        this.systemMapErrorMessage = 'There was an error deleting the maps.';
                        this.LoggingService.Log('Error deleting maps.', error_7, LogLevel.Error);
                        return [3 /*break*/, 7];
                    case 5:
                        if (mapsToDelete.filter(function (m) { return m.id === _this.mapViewRef.mapcoreViewProps.id; })) {
                            this.resetMap();
                        }
                        return [4 /*yield*/, this.getUserMapsAndFoldersForUserId()];
                    case 6:
                        _a.sent();
                        this.loadFilteredUserMaps();
                        this.multiSelectEnabled = false;
                        mapsToDelete.forEach(function (x) { return x.selected = false; });
                        this.loading.status = false;
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.shareMulti = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_5, _a, mapsToShare, mailto, mapsToShare_1, mapsToShare_1_1, map;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        mapsToShare = this.mapsSelected;
                        if (!this.canViewUsers) return [3 /*break*/, 3];
                        if (!(mapsToShare.length > 0)) return [3 /*break*/, 2];
                        this.opensharemap.emit(mapsToShare);
                        return [4 /*yield*/, this.closeWindow()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        if (mapsToShare.every(function (x) { return x.isPublic; })) {
                            mailto = 'mailto:?';
                            mailto += "subject=" + environment.appName + ": New Shared Maps&";
                            try {
                                for (mapsToShare_1 = tslib_1.__values(mapsToShare), mapsToShare_1_1 = mapsToShare_1.next(); !mapsToShare_1_1.done; mapsToShare_1_1 = mapsToShare_1.next()) {
                                    map = mapsToShare_1_1.value;
                                    mailto += "body=I've shared a new map with you from " + environment.appName + " named " + map.name + ". You can view the map here: " + this.mapService.getMapUrl(map.id);
                                }
                            }
                            catch (e_5_1) { e_5 = { error: e_5_1 }; }
                            finally {
                                try {
                                    if (mapsToShare_1_1 && !mapsToShare_1_1.done && (_a = mapsToShare_1.return)) _a.call(mapsToShare_1);
                                }
                                finally { if (e_5) throw e_5.error; }
                            }
                            window.location.href = mailto;
                        }
                        _b.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.unshareMulti = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_6, _a, mapsToUnshare, mapsToUnshare_1, mapsToUnshare_1_1, map, userIds, e_6_1, e_7;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!window.confirm('Are you sure that you would like to remove all shared users from these maps?')) return [3 /*break*/, 13];
                        mapsToUnshare = this.mapsSelected;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 10, 11, 13]);
                        this.loading = { status: true, text: 'Unsharing Maps...' };
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 7, 8, 9]);
                        mapsToUnshare_1 = tslib_1.__values(mapsToUnshare), mapsToUnshare_1_1 = mapsToUnshare_1.next();
                        _b.label = 3;
                    case 3:
                        if (!!mapsToUnshare_1_1.done) return [3 /*break*/, 6];
                        map = mapsToUnshare_1_1.value;
                        userIds = map.sharedWith.map(function (x) { return x.userId; });
                        return [4 /*yield*/, this.mapService.unShareMap(userIds, map.id)];
                    case 4:
                        _b.sent();
                        _b.label = 5;
                    case 5:
                        mapsToUnshare_1_1 = mapsToUnshare_1.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_6_1 = _b.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (mapsToUnshare_1_1 && !mapsToUnshare_1_1.done && (_a = mapsToUnshare_1.return)) _a.call(mapsToUnshare_1);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 9: return [3 /*break*/, 13];
                    case 10:
                        e_7 = _b.sent();
                        this.systemMapErrorMessage = 'There was an error unsharing the maps.';
                        this.LoggingService.Log('Error unsharing maps.', e_7, LogLevel.Error);
                        return [3 /*break*/, 13];
                    case 11: return [4 /*yield*/, this.getUserMapsAndFoldersForUserId()];
                    case 12:
                        _b.sent();
                        this.loadFilteredUserMaps();
                        this.multiSelectEnabled = false;
                        mapsToUnshare.forEach(function (x) { return x.selected = false; });
                        this.loading.status = false;
                        return [7 /*endfinally*/];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    MapCatalogComponent.prototype.resetMap = function () {
        this.mapViewRef.mapcoreViewProps.id = null;
        if (this.mapViewRef.mapcoreViewProps.layers) {
            this.mapViewRef.mapcoreViewProps.layers.forEach(function (layer) {
                layer.id = null;
            });
        }
    };
    MapCatalogComponent.prototype.closeWindow = function () {
        this.userMapNodes = null;
        this.ondone.emit(true);
    };
    MapCatalogComponent.prototype.mapOpened = function (e) {
        this.onmapopened.emit(e);
    };
    MapCatalogComponent.prototype.mapMerged = function (e) {
        this.mergeMaps = false;
        this.openmergemap.emit(e);
        this.closeWindow();
    };
    MapCatalogComponent.prototype.nameInUse = function (control) {
        var _this = this;
        var parentFolder = this.parentFolders.find(function (f) { return f.id === _this.currentFolderId; });
        if (this.currentFolderId && (!parentFolder || control.value === parentFolder.name)) {
            return null;
        }
        return this.parentFolders
            .map(function (f) { return f.name; })
            .includes(control.value) ? { nameInUse: { value: control.value } } : null;
    };
    MapCatalogComponent.prototype.logIn = function (event) {
        this.shouldLogIn.emit(event);
    };
    MapCatalogComponent.prototype.toggleMultiSelect = function () {
        this.multiSelectEnabled = !this.multiSelectEnabled;
    };
    MapCatalogComponent.prototype.isUserOwnerOfMap = function (map) {
        return map.accessLevel === 'OWNER';
    };
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean)
    ], MapCatalogComponent.prototype, "showOnlyApplicationUserMaps", void 0);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], MapCatalogComponent.prototype, "showSystemMaps", null);
    tslib_1.__decorate([
        InputConverter(BooleanConverter),
        tslib_1.__metadata("design:type", Boolean),
        tslib_1.__metadata("design:paramtypes", [Boolean])
    ], MapCatalogComponent.prototype, "showUserMaps", null);
    return MapCatalogComponent;
}(BaseComponent));
export { MapCatalogComponent };
